<script>
  // Vuetify changed genFilteredText function to return vNode instead of html in v2.6.10
  // This component returns the corresponding html
  // It could be used more globally as a vNode => html convertor

  export default {
    functional: true,
    props: {
      vnodes: { type: [String, Array], required: true },
    },
    render(h, ctx) {
      return typeof ctx.props.vnodes == 'string' ? [ctx.props.vnodes] : ctx.props.vnodes;
    },
  };
</script>
